import type { FC } from 'react';
import React from 'react';
import type { SidebarMenuItem } from '../classes/SidebarMenuItem';
import { Block } from '@klp/design';
import {
    Divider,
    ListItem,
    ListItemIcon,
    ListItemText,
} from '@material-ui/core';
import { Link as RouteLink } from 'react-router-dom';
import { useAppParams } from '@forvalter/packages/appParams/useAppParams';
import { useSelector } from 'react-redux';
import { contextSelectors } from '@klp/contextSelector';
import { Illustration } from '@klp/design/Illustrations';
import { useTranslation } from 'react-i18next';
import { useCurrentUser } from '@klp/auth';
import { useLayoutContext } from '@klp/layout/Layout/LayoutContext';

type NestedSidebarItemProps = {
    element: SidebarMenuItem;
};

export const NestedSidebarMenuSubitem: FC<NestedSidebarItemProps> = ({
    element,
}) => {
    const { t } = useTranslation();
    const { matchRoute } = useAppParams();
    const { currentUser } = useCurrentUser();

    const { setMenuOpen } = useLayoutContext();
    const { selectedContext } = useSelector(contextSelectors);

    const handleDrawerClose = () => {
        setMenuOpen(false);
    };

    const { access, condition } = element;
    if (access && access?.(currentUser) === false) return null;
    if (condition && condition?.(element) === false) return null;

    return (
        <>
            {element.divider && (
                <Block marginVertical="compact">
                    <Divider />
                </Block>
            )}
            {!element.divider && (
                <ListItem
                    button={true}
                    {...(element.route && {
                        component: RouteLink,
                        to: element.route,
                    })}
                    selected={matchRoute(element.matchRoute || '')}
                    onClick={() => {
                        handleDrawerClose();
                        if (element?.callback) {
                            element?.callback(selectedContext?.id ?? '', '');
                        }
                    }}
                >
                    <ListItemIcon>
                        {element.pictogram && (
                            <Illustration pictogram={element.pictogram} />
                        )}
                        {element.icon && (
                            <Illustration
                                icon={element.icon}
                                klpColor="veryLight"
                                klpPalette="primary"
                            />
                        )}
                    </ListItemIcon>
                    <ListItemText primary={t(element.translation || '')} />
                </ListItem>
            )}
        </>
    );
};
